export default __webpack_public_path__ + "static/media/contact-avatar-ru.09d6acfc.png";